module.exports={"Clear search":"Tøm søk"};